module.exports = "/_next/static/images/c35f283083b676d716d45757a79785ae-sanpablo-1-desktop.jpg";